import {Component, Input} from '@angular/core';

@Component({
  selector: 'si-gray-card',
  templateUrl: './gray-card.component.html',
  styleUrls: ['./gray-card.component.scss']
})
export class GrayCardComponent {
  @Input() keyValues = [];
  @Input() hideEmptyValues = false;
}
